import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetQandasByFund(useCache = true) {
  const [state, q] = useAxios({
    cache: { ignoreCache: !useCache },
    url: '/api/v1/fund/-1/qandas',
    method: 'GET',
  }, { manual: true });
  const executeQuery = React.useCallback(id => q({ url: `/api/v1/fund/${id}/qandas` }), [q]);
  return [state, executeQuery];
}
